module.exports = __webpack_public_path__ + "fonts/notosans-semibold-web.99cab5f.woff2";